import { render, staticRenderFns } from "./ClickDataTable.vue?vue&type=template&id=5f620218&"
import script from "./ClickDataTable.vue?vue&type=script&lang=js&"
export * from "./ClickDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports